import { ReplacerObject } from '../../../../Dictionary/DictionaryTypes'
import { exists } from '../../../../UtilityHelpers/exists'
import { StandardValidationConstraintKeys } from '../_constants/standard-validation-constraint-keys'
import { STANDARD_VALIDATION_MESSAGE_KEYS as MESSAGE_KEYS } from '../_constants/standard-validation-message-keys'

interface DictionaryTextProps {
    textKey: string
    replacer?: ReplacerObject
}

export type ValidationMessageType = {
    [key in StandardValidationConstraintKeys]?: DictionaryTextProps
}
/**
 * @memberof generateSchema
 * */
export const constructStandardValidationMessage = (key: StandardValidationConstraintKeys, constraint?: number | string): ValidationMessageType => {
    return { [key]: { textKey: MESSAGE_KEYS[key], replacer: exists(constraint) ? { [key?.toLowerCase()]: constraint } : undefined } }
}
